export default "__VITE_ASSET__AgPmqC6Y__";